import type { Role } from '../../../typings/api';
import { get, post, put, remove } from '../api';

export const CLEAR_ROLES_ERRORS = 'CLEAR_ROLES_ERRORS';
export const SET_EDITING_ROLE = 'SET_EDITING_ROLE';
export const SET_EDITING_PERMISSIONS = 'SET_EDITING_PERMISSIONS';
export const UPDATE_EDITING_ROLE = 'UPDATE_EDITING_ROLE';
export const CLEAR_EDITING_ROLE = 'CLEAR_EDITING_ROLE';
export const CLONE_ROLE = 'CLONE_ROLE';

export const FETCH_ALL_ROLES = 'FETCH_ALL_ROLES';
export const DELETE_ROLE = 'DELETE_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const CREATE_ROLE = 'CREATE_ROLE';

const roleActions = {
  fetchAll: (filters: object = {}) => ({
    type: FETCH_ALL_ROLES,
    async payload() {
      return get(`/api/roles`, true, filters);
    },
  }),

  create: (role: Role) => ({
    type: CREATE_ROLE,
    async payload() {
      return post(`/api/roles`, role);
    },
  }),

  update: (role: Role) => ({
    type: UPDATE_ROLE,
    meta: {
      id: role.id,
    },
    async payload() {
      return put(`/api/roles/${role.id}`, role);
    },
  }),

  delete: (teamId: number) => {
    return {
      type: DELETE_ROLE,
      meta: {
        id: teamId,
      },
      async payload() {
        return remove(`/api/roles/${teamId}`);
      },
    };
  },
  clearErrors: () => ({
    type: CLEAR_ROLES_ERRORS,
  }),
  //  When the OrganizationRolesEdit component mounts, it grabs the id from the state and sets that role as the "Active" editing role.
  setEditingRole: (roleId: string | null) => ({
    type: SET_EDITING_ROLE,
    roleId,
  }),
  //  When editing an existing role, this action takes the incoming permissions and sets them.
  setEditingPermissions: (permissions: Role['permissions']) => ({
    type: SET_EDITING_PERMISSIONS,
    permissions,
  }),
  //  Single action for updating the roles.editingRole. Folds prev state into it, so it's a partial.
  updateEditingRole: (updatedEditingRole: Partial<Role> = {}) => ({
    type: UPDATE_EDITING_ROLE,
    updatedEditingRole,
  }),
  //  When the user is editing and clicks "cancel", this clears out the editingRole state.
  clearEditingRole: () => ({
    type: CLEAR_EDITING_ROLE,
  }),
  //  Works almost the same as updateEditingRole, but without checking for scope change/unchecking out-of-scope permissions.
  cloneRole: (clonedRole: Partial<Role> = {}) => ({
    type: CLONE_ROLE,
    clonedRole,
  }),
};

export default roleActions;
